import { Controller } from "@hotwired/stimulus";

// Shows the pickers and email settings that apply to the selected audience, and filters the user lists.
export default class extends Controller {
  static targets = [
    "audience",
    "grants",
    "roleGrants",
    "notify",
    "notifyToggle",
    "teamHint",
    "message",
    "link",
    "tenantOnly",
  ];

  connect() {
    this.toggle();
    this.toggleRinsedUsers();
  }

  toggle() {
    const audience = this.audienceTarget.value;

    this.grantsTarget.hidden = audience !== "specific";
    this.roleGrantsTarget.hidden = audience !== "roles";
    this.linkTarget.hidden = audience !== "specific";
    this.notifyTarget.hidden = audience === "personal";
    this.teamHintTarget.hidden = audience !== "team";

    // A team-wide announcement reaches everyone with analytics, so it's opt-in; naming a few
    // teammates or roles usually means you want them told. Applied on first render too, then only on
    // a real change, so a deliberate flip of the checkbox survives any later re-run.
    if (audience !== this.lastAudience) {
      this.notifyToggleTarget.checked =
        audience === "specific" || audience === "roles";
    }
    this.lastAudience = audience;

    this.toggleMessage();
  }

  toggleMessage() {
    this.messageTarget.hidden =
      this.notifyTarget.hidden || !this.notifyToggleTarget.checked;
  }

  // Rows stay in the DOM so anyone already picked stays picked.
  toggleRinsedUsers() {
    if (!this.hasTenantOnlyTarget) return;

    const excluded = this.tenantOnlyTarget.checked;
    this.element.querySelectorAll("[data-rinsed-user]").forEach((option) => {
      option.dataset.uiFilterExcluded = excluded ? "true" : "false";
      option.classList.toggle("hidden", excluded);
    });

    // Re-run each picker's search so the rows match the toggle and whatever is typed.
    this.element
      .querySelectorAll("[data-ui--filter-target='source']")
      .forEach((input) =>
        input.dispatchEvent(new Event("input", { bubbles: true })),
      );
  }
}
